module.exports = __webpack_public_path__ + "static/media/angle-left.44f561ae.svg";